// Add these to the Arabic dashboard translations
export const arOrdersTranslations = {
	orders: {
		// Orders page
		title: 'الطلبات',
		subtitle: 'إدارة وتتبع جميع طلبات مطعمك',
		createManualOrder: 'إنشاء طلب يدوي',
		orderDetails: 'تفاصيل الطلب',

		// Order table columns/headers
		orderId: 'رقم الطلب',
		customer: 'العميل',
		items: 'العناصر',
		total: 'المجموع',
		status: 'الحالة',
		date: 'التاريخ',
		viewDetails: 'عرض التفاصيل',
		amount: 'المبلغ',
		actions: 'الإجراءات',
		orders: 'الطلبات',

		// Order statuses
		statusPending: 'قيد الانتظار',
		statusProcessing: 'قيد المعالجة',
		statusCompleted: 'مكتمل',
		statusPreparing: 'قيد التحضير',
		statusDelivered: 'تم التوصيل',
		statusCancelled: 'ملغي',
		updateStatus: 'تحديث الحالة',

		// Payment statuses and methods
		paymentStatus: 'حالة الدفع',
		paymentPending: 'الدفع معلق',
		paid: 'مدفوع',
		refunded: 'مسترد',
		creditCard: 'بطاقة ائتمان',
		cash: 'نقداً',
		onlinePayment: 'دفع إلكتروني',

		// Filters and sorting
		filter: 'تصفية',
		filterByStatus: 'تصفية حسب الحالة',
		filterByDate: 'تصفية حسب التاريخ',
		sortBy: 'ترتيب حسب',
		dateRange: 'نطاق التاريخ',
		startDate: 'تاريخ البدء',
		endDate: 'تاريخ الانتهاء',

		// Date filter options
		allTime: 'كل الوقت',
		today: 'اليوم',
		yesterday: 'أمس',
		thisWeek: 'هذا الأسبوع',
		lastWeek: 'الأسبوع الماضي',
		thisMonth: 'هذا الشهر',
		lastMonth: 'الشهر الماضي',
		customRange: 'نطاق مخصص',

		// Customer info
		customerInfo: 'معلومات العميل',

		// Delivery info
		deliveryInfo: 'معلومات التوصيل',
		delivery: 'توصيل',
		pickup: 'استلام',
		dineIn: 'تناول في المطعم',
		deliveryAddress: 'عنوان التوصيل',
		deliveryTime: 'وقت التوصيل',

		// Payment info
		paymentInfo: 'معلومات الدفع',
		subtotal: 'المجموع الفرعي',
		tax: 'الضريبة',
		tip: 'الإكرامية',
		discount: 'الخصم',

		// Notes and actions
		notesAndActions: 'الملاحظات والإجراءات',
		orderNotes: 'ملاحظات الطلب',
		noNotes: 'لا توجد ملاحظات لهذا الطلب',
		printOrder: 'طباعة الطلب',
		generateInvoice: 'إنشاء فاتورة',
		contactCustomer: 'الاتصال بالعميل',

		// Error states
		orderNotFound: 'الطلب غير موجود',
		orderNotFoundDescription: 'الطلب الذي تبحث عنه غير موجود أو تمت إزالته.',
		noOrdersMatchingFilters: 'لا توجد طلبات تطابق المرشحات',
		noOrdersYet: 'لا توجد طلبات حتى الآن',

		ordersOverTime: 'الطلبات مع مرور الوقت',
		totalOrders: 'إجمالي الطلبات',
		revenue: 'الإيرادات',
	},
};